import { parse } from 'query-string';

export const SORT_CATEGORY = 'SORT_CATEGORY';

export function sortCategory(categoryId, qs = '', e) {
    return {
        type: SORT_CATEGORY,
        payload: {
            direction: null,
            requestType: SORT_CATEGORY,
            requestStatus: 'MAKING_REQUEST',
            categoryId: categoryId,
            queryString: qs,
            queryObj: parse(qs)
        },
        meta: {
            event: e
        }
    };
}
